import React from 'react';
import { useConnect } from '@lore/query-connect';
import { tags_educator } from '../../../../utils/query-helpers';

export default function useEducators(state, network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('user.find', {
    where: {
      eager: {
        $where: {
          ...tags_educator(),
          // networkId: network?.id,
          state: {
            $ilike: state
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra
        },
        $eager: eager
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
